export const cutPid = (pid?: string) => {
  if (!pid) return;
  const pidSplited = pid.split('-');

  return pidSplited[0];
};
